/** Must match services/mt5/sanitizeSymbolPrices.ts MAX_SPREAD_FRACTION. */
export const MT5_MAX_SPREAD_FRACTION = 0.005;

export function isUsableMt5Quote(bid: unknown, ask: unknown): boolean {
  if (typeof bid !== 'number' || typeof ask !== 'number') return false;
  if (!Number.isFinite(bid) || !Number.isFinite(ask) || bid <= 0 || ask <= 0) return false;
  if (ask < bid) return false;
  return (ask - bid) / bid <= MT5_MAX_SPREAD_FRACTION;
}
